/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./portfolio.css";
import IMG from "../../assets/socialMedia.png";
import IMG1 from "../../assets/ecommers.png";
import IMG2 from "../../assets/lerning.png";
import IMG3 from "../../assets/film.png";
import IMG4 from "../../assets/weather.jpg";

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portlio__container">
        <article className="portfolio__item">
          <div className="portfoloio__item-image">
            <img src={IMG} alt="" />
          </div>
          <h3>Social Media</h3>
          <small>MERN stack project</small>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/YusupovJaloliddin/SocilaMediaApp"
              className="btn"
            >
              Git Hub
            </a>
            <a
              href="https://socialmedia4633.herokuapp.com/"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfoloio__item-image">
            <img src={IMG1} alt="" />
          </div>
          <h3>Eccommerce</h3>
          <small>NodeJs ExpressJs MongoDB</small>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/YusupovJaloliddin/ECOMMERCE"
              className="btn"
            >
              Git Hub
            </a>
            <a
              href="!#"
              onClick={(e) => {
                e.preventDefault();
                alert("Only the backend part of this site is recorded");
              }}
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfoloio__item-image">
            <img src={IMG2} alt="" />
          </div>
          <h3>Online Learning</h3>
          <small>NodeJs ExpressJs MongoDB</small>

          <div className="portfolio__item-cta">
            <a
              href="https://github.com/YusupovJaloliddin/VertualDars"
              className="btn"
            >
              Git Hub
            </a>
            <a
              href="!#"
              onClick={(e) => {
                e.preventDefault();
                alert("Only the backend part of this site is recorded");
              }}
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfoloio__item-image">
            <img src={IMG3} alt="" />
          </div>
          <h3>Telegram Bot</h3>
          <small>TelegramBot mini project</small>

          <div className="portfolio__item-cta">
            <a
              target="_blank"
              href="https://github.com/YusupovJaloliddin/TelegramBot"
              className="btn"
            >
              Git Hub
            </a>
            <a
              href="!#"
              onClick={(e) => {
                e.preventDefault();
                alert("Only the backend part of this site is recorded");
              }}
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        <article className="portfolio__item">
          <div className="portfoloio__item-image">
            <img src={IMG4} alt="" />
          </div>
          <h3>Weather App</h3>
          <small>Javascript project</small>

          <div className="portfolio__item-cta">
            <a
              href="https://github.com/YusupovJaloliddin/Weather-App"
              className="btn"
            >
              Git Hub
            </a>
            <a
              href="https://weather-app-javascript4633.netlify.app"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article>
        {/* <article className="portfolio__item">
          <div className="portfoloio__item-image">
            <img src={IMG} alt="" />
          </div>
          <h3>Social Media</h3>
          <div className="portfolio__item-cta">
            <a href="http://github.com" className="btn">
              Git Hub
            </a>
            <a
              href="https://socialmedia4633.herokuapp.com/"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </article> */}
      </div>
    </section>
  );
};

export default Portfolio;
